import { useState, useEffect, useRef }from 'react';
import { INIT_ENCOUNTER_NAME, handleOpenSession } from '../../constants';
import refresh from '../../pics/icons/refresh.png';
import greenCheck from '../../pics/icons/check.png'; 
import eyeClosed from '../../pics/icons/eyeClosed.png'; 
import eyeOpen from '../../pics/icons/eyeOpen.png'; 
import playerViewOptions from "../../pics/icons/playerviewOptionsButton.png"
import ImagePopup from "./ImagePopup"
import SharePvImagePopup from "./SharePvImagePopup"
import Timer from './Timer';
import RefreshTimer from './RefreshTimer';
import OptionButton from './OptionButton';
import streamingGif from '../../pics/icons/streaming.gif';
import streamingImg from '../../pics/icons/streamingImg.png';
import quickEditImg from '../../pics/icons/quickEdit.png';
import notesImg from '../../pics/icons/notes.png';
import useShakeAnimation from '../../Hooks/useShakeAnimation';
import WidgetPopUp from './WidgetPopUp';
import { useUser } from '../../../../../providers/UserProvider';
import Tooltip from '../Tooltip';
import SaveToFolderWidget from './SaveToFolderWidget';
import EditNotesTextArea from './EditNotesTextArea';
import PlayerViewBloodPreviewTabs from './PlayerIconPreview/PlayerViewBloodPreviewTabs';

import SpotifyWidget from './MusicWidget/SpotifyWidget';

const EncounterControls = ({savedEncounters, streamingEncounter, setStreamingEncounter, handleTurnNums, currentEncounter, refreshLoading, setCurrentEncounter, setPlayerViewBackground, handleRefresh, refreshCheck, autoRefresh, handleAutoRollInitiative, setNameChange, setDefaultBackgroundOverride, quickEdit, setQuickEdit, socket}) => {
    const [showRefreshButton, setShowRefreshButton] = useState(autoRefresh);

    const [encounterName, setEncounterName] = useState(currentEncounter.encounterName);
    const [hideEnemies, setHideEnemies] = useState(currentEncounter.hideEnemies);
    const [anyEnemyVisible, setAnyEnemyVisible] = useState(currentEncounter.creatures.filter(creature => !creature.hidden && creature.type !== "player").length);
    const [isStreaming, setIsStreaming] = useState(streamingEncounter?.encounterGuid === currentEncounter.encounterGuid);
    const {sessionID, prefs} = useUser()
    const shakeRef = useShakeAnimation(anyEnemyVisible);

    useEffect(() => {
        setIsStreaming(streamingEncounter?.encounterGuid === currentEncounter.encounterGuid)
    }, [streamingEncounter?.encounterGuid]);

    useEffect(() => {
        setEncounterName(currentEncounter.encounterName)
        setHideEnemies(currentEncounter.hideEnemies)
        setAnyEnemyVisible(currentEncounter.creatures.filter(creature => !creature.hidden && creature.type !== "player").length);
        setIsStreaming(streamingEncounter?.encounterGuid === currentEncounter.encounterGuid)

        // eslint-disable-next-line
    }, [currentEncounter]);

    useEffect(() => {
        setCurrentEncounter({...currentEncounter, hideEnemies: hideEnemies});
        // eslint-disable-next-line
    }, [hideEnemies]);

    useEffect(() => {
        setShowRefreshButton(autoRefresh)
    }, [autoRefresh]);  

    const handleHideEnemies = () => {
        if(autoRefresh && hideEnemies) // If hideEnemies is true, then refresh before revealing enemies
            handleRefresh()

        setHideEnemies(!hideEnemies)
        socket.emit("controlHiddenToggle", !hideEnemies, currentEncounter.encounterGuid)
    } 

    let titleColor = encounterName === INIT_ENCOUNTER_NAME ? 'grey' : ''
    let {roundNum, turnNum} = handleTurnNums()

    const handleTitleChange = (e) => {
        if (encounterName !== e.target.value) {
            setEncounterName(e.target.value);
        }
    };

    const handleEncounterNameChange = (e) => {
        if (currentEncounter.encounterName !== e.target.value) {
            setEncounterName(e.target.value);
            setCurrentEncounter(prev => ({...prev, encounterName: e.target.value}))
            setNameChange(true)

            if(currentEncounter.creatures.length === 0 && encounterName === INIT_ENCOUNTER_NAME) {
                socket.emit("newEncounter", currentEncounter.encounterGuid, '', currentEncounter.folder_dir)
            }

            socket.emit("encounterNameChange", e.target.value, currentEncounter.encounterGuid)
        }
    };

    const handleStartStream = () => { 
        if(isStreaming) {
            socket.emit("stopStreaming",  currentEncounter.encounterGuid, currentEncounter.encounterName, sessionID)
            setStreamingEncounter({encounterName: null, encounterGuid: null})
            setIsStreaming(false)
        } else {
            socket.emit("startStreaming", currentEncounter.encounterGuid, currentEncounter.encounterName, sessionID)
            
            if(window.localStorage.getItem("playerViewOpen") === 'false') {
                handleOpenSession(sessionID)
            }

            setStreamingEncounter({encounterName: currentEncounter.encounterName, encounterGuid: currentEncounter.encounterGuid})
            setIsStreaming(true)

        }
    }
    
    const isBackgroundImage = !currentEncounter.backgroundGuid.includes("www.youtube.com")

    return (
        <div className='encounterControlsContainer'>
            <div className='folderLineFlex'>
                <div className='folderWrapper'>
                    <p className='folderTextInput'>
                        <i>Folder: <b>{currentEncounter.folder_dir || 'None'}</b></i>
                    </p>
                    <SaveToFolderWidget
                        currentEncounter={currentEncounter}
                        setCurrentEncounter={setCurrentEncounter}
                        socket={socket}
                        isBackgroundImage={isBackgroundImage}
                        backgroundUrl={currentEncounter.backgroundGuid}
                        savedEncounters={savedEncounters}
                    />   
                </div>
                <div className='folderLineExtra'>
                    <WidgetPopUp 
                        triggerClass='notesOptionsWrapper'
                        trigger={
                            <OptionButton src={notesImg} message={"Encounter Notes"} imgClassName='removeMargin' />
                        }
                        popUp={
                            <EditNotesTextArea currentEncounter={currentEncounter} setCurrentEncounter={setCurrentEncounter} socket={socket}/>
                        }
                        side='bottom' 
                        sideOffset={20}
                        alignOffset={-33}
                        popOverClassContainer={"arrowPopOver"}
                    />
                    <i className="notesOptionsWrapper">
                        {sessionID !== null &&
                            <OptionButton imgStyle={{border: `2px solid ${isStreaming ? 'green' : 'red'}`, backgroundColor: 'white'}} imgClassName='streamingGif removeMargin' src={isStreaming ? streamingGif : streamingImg} message={isStreaming ? 'Stop Streaming'  : `Stream: ${currentEncounter.encounterName}`} onClickFunction={handleStartStream}/>
                        }
                    </i>
                    <i className="streamingText">
                        {(streamingEncounter.encounterGuid && streamingEncounter.encounterGuid !== currentEncounter.encounterGuid) && <><i style={{fontSize: "13px"}}>Streaming: <b>{streamingEncounter.encounterName}</b></i></>}
                    </i>
                </div>
            </div>

            <input style={{color: titleColor}} className='titleInput nameInput' type='text' value={encounterName} onChange={handleTitleChange} onBlur={handleEncounterNameChange} onClick={(event) => event.target.select()}/>
               
            <div className='encounterControls'> 
                <div className='encounterControlsLeft'>
                    <div className='dmStartButtons'>
                        <div className='dmStartButtonsContainer'>
                            <button className='dmViewButton' onClick={(e) => handleAutoRollInitiative("roll", e)} title='Roll Initiative for NPCs'>Roll Init.</button>
                            <button className='dmViewButtonInvis' onClick={(e) => handleAutoRollInitiative("clear", e)} title='Clear All Init.'>⟳</button>
                        </div>
                        <OptionButton src={quickEditImg} imgStyle={quickEdit ? {outline: "2px solid red"} : {}} message={"Quick Edit"} onClickFunction={() => setQuickEdit(p => !p)}/>
                        <ImagePopup setPlayerViewBackground={setPlayerViewBackground} setDefaultBackgroundOverride={setDefaultBackgroundOverride} encounterGuid={currentEncounter.encounterGuid} socket={socket}/>                    
                        <SharePvImagePopup socket={socket}/>                    
                        {showRefreshButton &&
                            <OptionButton src={refreshCheck ? greenCheck : refresh} message={<RefreshTimer refresh={refreshCheck}/>} onClickFunction={() => handleRefresh()} imgClassName={refreshLoading ? 'spinningImage' : ''} />
                        }         
                        <Timer />   
                    </div>
                </div>
                <div className='encounterControlsRight'>
                    {currentEncounter.creatures.length > 0 && 
                        <div className='dmLowOptions'>
                            <div className='encounterArrowsContainer'>
                                <WidgetPopUp 
                                    openOnHover={true}
                                    trigger={
                                        <div className='dmStartButtonsContainer'>
                                            <div className='dmStartButtons'>
                                                <div className='encounterTitleButtonGroup' onClick={(e) => e.stopPropagation()}>
                                                    <button className='turnButton' onClick={(e) => handleTurnNums('prev', e)}> 
                                                        <svg width="20" height="20" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                                            <polygon points="32,28 56,48 56,8" fill="#000000"/>
                                                            <polygon points="8,26 32,48 32,8" fill="#000000"/>
                                                        </svg>
                                                    </button>
                                                    <div className='turnText'>
                                                        R: {roundNum} - T: {turnNum} 
                                                    </div>
                                                    <button className='turnButton' onClick={(e) => handleTurnNums('next', e)}> 
                                                        <svg width="20" height="20" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                                            <polygon points="32,28 8,50 8,8" fill="#000000"/>
                                                            <polygon points="56,28 32,50 32,8" fill="#000000"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <button className='dmViewButtonInvis' onClick={(e) => handleTurnNums('reset', e)} title='Reset Counter'>⟳</button>
                                            </div>
                                        </div>
                                    }
                                    popUp={
                                        <div>
                                            <Tooltip message={"Arrow Keys Shortcut: ← →"}/>
                                        </div>
                                    }
                                    side='top' 
                                    sideOffset={5}
                                    alignOffset={50}
                                    popOverClassContainer={"arrowPopOver"}
                                />
                            </div>
                            <OptionButton src={hideEnemies ? eyeClosed : eyeOpen} message={"Enemies " + (hideEnemies ? "Hidden" : "Visible")} onClickFunction={handleHideEnemies} imgRef={hideEnemies ? shakeRef : null}/>
                            <div>
                                <WidgetPopUp 
                                    trigger={
                                        <OptionButton src={playerViewOptions} message={`PlayerView Options${currentEncounter.hideAll ? ' - All Icons Hidden' : ''}${prefs.useGlobalPvOptions ? ' - Global ON' : ''}`} 
                                            imgStyle={{
                                                outline: currentEncounter.hideAll ? '1px solid rgba(201, 130, 125)' : '',
                                                animation: currentEncounter.hideAll ? 'hideAllShadowPulse 3s ease-in-out infinite' : ''
                                            }} 
                                        />
                                    }
                                    popUp={
                                        <PlayerViewBloodPreviewTabs currentEncounter={currentEncounter} setCurrentEncounter={setCurrentEncounter} socket={socket}/>
                                    }
                                    side='bottom'
                                    alignOffset={35}
                                    sideOffset={-170}
                                />
                            </div>
                            <div>
                                <SpotifyWidget
                                    currentEncounter={currentEncounter}
                                    setCurrentEncounter={setCurrentEncounter}
                                    socket={socket}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default EncounterControls;